export enum TransactionTypes {
    Bookings = 0,
    Registration = 1,
    Fund = 2,
}
